import { ApiResponse } from 'apisauce';
import {
  ILoadBal,
  ILoadBalSnapshot,
  INasVol,
  INasVolSnapshot,
  INks,
  INksSnapshot,
} from 'src/models';

import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteInfraManagementResult,
  TGetLoadBalResult,
  TGetNasVolResult,
  TGetNksResult,
  TSaveLoadBalResult,
  TSaveNasVolResult,
  TSaveNksResult,
} from './InfraManagementTypes';

export class InfraManagementApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getLoadBal(options?: { useYn?: 'Y' | 'N' }): Promise<TGetLoadBalResult> {
    try {
      const url = '/loadBal';
      const params = options ?? {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const loadBal: ILoadBal[] = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', loadBal, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async saveLoadBal(newLoadBal: ILoadBalSnapshot): Promise<TSaveLoadBalResult> {
    try {
      const hasSid = !!newLoadBal.loadBalSid;
      const url = hasSid ? `/loadBal/${newLoadBal.loadBalSid}` : '/loadBal';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newLoadBal);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const loadBal: ILoadBal = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', loadBal, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async deleteLoadBal(loadBalSid: number): Promise<TDeleteInfraManagementResult> {
    try {
      const url = `/loadBal/${loadBalSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getNasVol(options?: { useYn?: 'Y' | 'N' }): Promise<TGetNasVolResult> {
    try {
      const url = '/nasVol';
      const params = options ?? {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const nasVol: INasVol[] = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', nasVol, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async saveNasVol(newNasVol: INasVolSnapshot): Promise<TSaveNasVolResult> {
    try {
      const hasSid = !!newNasVol.nasVolSid;
      const url = hasSid ? `/nasVol/${newNasVol.nasVolSid}` : '/nasVol';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newNasVol);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const nasVol: INasVol = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', nasVol, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async deleteNasVol(nasVolSid: number): Promise<TDeleteInfraManagementResult> {
    try {
      const url = `/nasVol/${nasVolSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      // return null;
      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async getNks(options?: { useYn?: 'Y' | 'N' }): Promise<TGetNksResult> {
    try {
      const url = '/nks';
      const params = options ?? {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const nks: INks[] = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', nks, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async saveNks(newNks: INksSnapshot): Promise<TSaveNksResult> {
    try {
      const hasSid = !!newNks.clstrSid;
      const url = hasSid ? `/nks/${newNks.clstrSid}` : '/nks';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newNks);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const nks: INks = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', nks, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
  async deleteNks(nksSid: number): Promise<TDeleteInfraManagementResult> {
    try {
      const url = `/nks/${nksSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      // return null;
      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
